export default __webpack_public_path__ + "static/media/yt1.daa5cb28.svg";